import ExcelJS from 'exceljs';
import { download } from '../../../../../../utils/download';

export const downloadPayrollTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Employee Payroll Template');

  const headers = [
    { label: 'Employee Number', required: true },
    { label: 'First Name', required: true },
    { label: 'Middle Initial', required: false },
    { label: 'Last Name', required: true },
    { label: 'Address 1', required: true },
    { label: 'Address 2', required: false },
    { label: 'City', required: true },
    { label: 'State', required: true },
    { label: 'Zip Code', required: true },
    { label: 'Birth Date', required: true },
    { label: 'Hire Date', required: true },
    { label: 'Gender', required: true },
    { label: 'Pay Type (hourly or salary)', required: true },
    { label: 'Rate', required: true },
    { label: 'Federal Filing Status', required: true },
    { label: 'Federal W4 Dependent Credit Amount', required: true },
    { label: 'State Filing Status', required: false },
    { label: 'State Exemptions', required: false },
  ];

  worksheet.columns = headers.map((header) => ({
    header: header.label,
    key: header.label,
    width: Math.max(header.label.length + 4, 16),
  }));

  worksheet.getRow(1).eachCell((cell, colNumber) => {
    cell.font = { bold: headers[colNumber - 1]?.required };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  download(buffer, 'Employee Payroll Template.xlsx');
};
